module.exports = __webpack_public_path__ + "img/circleInactive.823fa24b.svg";